/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

const baseUrl = 'academy/learning-center/recommendations';
const pathParameterPlaceholder = undefined;
function freeze(value) {
  return Object.freeze(value);
}

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV1` from
 * `rpc-client-utils`.
 *
 * get-/academy/learning-center/recommendations/v2/homepage/{language}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:RecommendationResource+type:symbol+getRecommendations&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Recommendation-get-%2Facademy%2Flearning-center%2Frecommendations%2Fv2%2Fhomepage%2F%7Blanguage%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Facademy%2Flearning-center%2Frecommendations%2Fv2%2Fhomepage%2F%28%28%7Blanguage%7D%29%29?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getMLRecommendationsRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v2/homepage', pathParameterPlaceholder]),
  pathParameters: freeze(['language'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV1` from
 * `rpc-client-utils`.
 *
 * get-/academy/learning-center/recommendations/v2/{entityType}/{id}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:RecommendationResource+type:symbol+getRecommendationForEntity&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Recommendation-get-%2Facademy%2Flearning-center%2Frecommendations%2Fv2%2F%7BentityType%7D%2F%7Bid%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Facademy%2Flearning-center%2Frecommendations%2Fv2%2F%28%28%7BentityType%7D%29%29%2F%28%28%7Bid%7D%29%29?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getRecommendationsForEntityRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v2', pathParameterPlaceholder, pathParameterPlaceholder]),
  pathParameters: freeze(['entityType', 'id'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV1` from
 * `rpc-client-utils`.
 *
 * post-/academy/learning-center/recommendations/v2/content-engaged
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:RecommendationResource+type:symbol+engageContentInteraction&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Recommendation-post-%2Facademy%2Flearning-center%2Frecommendations%2Fv2%2Fcontent-engaged'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/post/api.hubapi.com%2Facademy%2Flearning-center%2Frecommendations%2Fv2%2Fcontent-engaged?showRequestDetails=true&body=%7B%22entityId%22:0,%22entityType%22:%22string%22,%22engagedContentId%22:0,%22correlationId%22:%22string%22%7D&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const postRecommendationsContentEngagedRpc = freeze({
  baseUrl,
  method: 'post',
  pathSegments: freeze(['v2/content-engaged'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV1` from
 * `rpc-client-utils`.
 *
 * post-/academy/learning-center/recommendations/v2/feedback
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:RecommendationResource+type:symbol+feedback&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Recommendation-post-%2Facademy%2Flearning-center%2Frecommendations%2Fv2%2Ffeedback'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/post/api.hubapi.com%2Facademy%2Flearning-center%2Frecommendations%2Fv2%2Ffeedback?showRequestDetails=true&body=%7B%22entityId%22:0,%22entityType%22:%22string%22,%22correlationId%22:%22string%22%7D&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const postRecommendationsFeedbackRpc = freeze({
  baseUrl,
  method: 'post',
  pathSegments: freeze(['v2/feedback'])
});